import { connect } from 'react-redux';
import {
  fetchROItems,
  deleteROItem
} from '../../../redux/Reservation/sagas/ROItem/routines';
import {
  getIsFetching,
  getIsDeleting,
  getOrder
} from '../../../redux/Reservation/selectors/ro-item';
import {
  ROItemOnClear,
  ROItemOnChangePage,
  ROItemOnChangeOrder
} from '../../../redux/Reservation/actions/ro-item';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Reservation/selectors/ro-item/pagination';
import { getROItemSearchQuery } from '../../../redux/Reservation/selectors/components/ro-item-search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import ROItemList from '../../../components/reservations/ROItemList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getROItemSearchQuery(state);
  const order = getOrder(state);
  return {
    items: orderList(order, getCurrentPageItems(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state),
    isDeleting: getIsDeleting(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchROItems());
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchROItems(query));
      else dispatch(ROItemOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(ROItemOnClear());
      dispatch(fetchROItems(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(ROItemOnClear());
      dispatch(fetchROItems({ ...query, order }));
      dispatch(ROItemOnChangeOrder(order));
    },
    onDelete: item => {
      dispatch(deleteROItem(item));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ROItemList);
